import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BeachSite } from 'src/app/models/BeachSite';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { LOOKUP_AREA_TYPES } from 'src/app/models/lookupAreaTypes';
import { Council, Region, RegionTypes, isSubRegion } from 'src/app/models/SiteGroups';
import { sortBy, uniq, uniqWith } from 'lodash';
import { UserFeedbackDialogComponent } from 'src/app/shared/user-feedback-dialog/user-feedback-dialog.component';
import { DialogRef } from 'src/app/shared/CustomDialog/DialogRef';
import { DialogService } from 'src/app/shared/CustomDialog/DialogService';
import { CheckboxListValidators } from 'src/app/CustomValidators/CheckboxListValidators';
import { UserFeedbackModalDialogComponent } from 'src/app/shared/custom-modal-dialog/user-feedback-modal-dialog/user-feedback-modal-dialog.component';
import { TreeItemNode } from './region-council-tree-list/ChecklistDatabase';
import { Observe } from 'src/app/shared/custom-decorators/Observe';


@Component({
	selector: '[formGroup] app-region-council-beach-sites-selection, [formGroupName] app-region-council-beach-sites-selection',
	templateUrl: './region-council-beach-sites-selection.component.html',
	styleUrls: ['./region-council-beach-sites-selection.component.scss']
})
export class RegionCouncilBeachSitesSelectionComponent implements OnInit, AfterViewInit, OnDestroy {	
	
	@Input() required : boolean = false;
	@Input() preSelectedCouncil$ : BehaviorSubject<string> = new BehaviorSubject<string>("");
	@Input() preSelectedBeachSite$ : BehaviorSubject<string> = new BehaviorSubject<string>("");

	

	private regionsSub : Subscription;
	private councilsSub : Subscription;
	private beachSitesSub : Subscription;
	
	public FILTER_BY = [LOOKUP_AREA_TYPES.Region, LOOKUP_AREA_TYPES.Council, LOOKUP_AREA_TYPES.BeachSite];
	public areaLookupTypes = LOOKUP_AREA_TYPES;

	private filterByValue : string;
	private nextFilterByChange = "";
	
	private regionsExpanded : number[] = [];
	private councilsExpanded : number[] = [];
	private searchText : string = "";

	
	popupDialogRef : DialogRef;
	suppressPopup : boolean = false;
	public dialogData : any = null;
	public showDialog : boolean = false;

	formGroup : FormGroup;	

	//private allBeachSites$ : BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);
	//private allRegions$ : BehaviorSubject<Region[]> = new BehaviorSubject<Region[]>([]);
	//private allCouncils$ : BehaviorSubject<Council[]> = new BehaviorSubject<Council[]>([]);

	@Input() allRegions : Region[];
	@Observe("allRegions") allRegions$! : Observable<any>;
	private subRegionsOnly : Region[] = [];

	@Input() allCouncils : Council[];
	@Observe("allCouncils") allCouncils$! : Observable<any>;

	@Input() allBeachSites : BeachSite[];
	@Observe("allBeachSites") allBeachSites$! : Observable<any>;
	
	


	// regionsTreeData : TreeItemNode[] = [];
	// councilsTreeData : TreeItemNode[] = [];
	// beachSitesTreeData : TreeItemNode[] = [];
	
	constructor(private fb : FormBuilder,
		private controlContainer: ControlContainer,
		private userfeedbackModaldialog : UserFeedbackModalDialogComponent,
		private dialog: DialogService)
	{

	}


	// @Input() 
	// get allBeachSites() {
	// 	return this.allBeachSites$.getValue();
	// }

	// set allBeachSites(value) {
	// 	this.allBeachSites$.next(value);
	// }

	// @Input() 
	// get allRegions() {
	// 	return this.allRegions$.getValue();
	// }

	// set allRegions(value) {
	// 	this.allRegions$.next(value);
	// }

	// @Input() 
	// get allCouncils() {
	// 	return this.allCouncils$.getValue();
	// }

	// set allCouncils(value) {
	// 	this.allCouncils$.next(value);
	// }	



	@Input()
	get preSelectedCouncil() {
		return this.preSelectedCouncil$.value;
	}
	
	set preSelectedCouncil(value : string) {
		this.preSelectedCouncil$.next(value);
	}

	
	@Input()
	get preSelectedBeachSite() {
		return this.preSelectedBeachSite$.value;
	}
	
	set preSelectedBeachSite(value : string) {
		this.preSelectedBeachSite$.next(value);
	}
	

	ngOnInit(): void {

		this.createFormControls();		

		this.formGroup = <FormGroup>this.controlContainer.control;
		
		this.formGroup?.addControl("regionsArray", this.fb.array([], 
			CheckboxListValidators.atleastOneCheckboxCheckedInFormGroup(LOOKUP_AREA_TYPES.RegionBeachSite)));
		this.formGroup?.addControl("councilsArray", this.fb.array([],
			CheckboxListValidators.atleastOneCheckboxCheckedInFormGroup(LOOKUP_AREA_TYPES.CouncilBeachSite)));

		this.formGroup?.addControl("beachSitesArray", this.fb.array([], CheckboxListValidators.atleastOneCheckboxChecked()));
		
		this.formGroup?.addControl("filterBy", this.fb.control("", Validators.required));		
		this.formGroup?.addControl("filterByKeyword", this.fb.control(""));
		
		this.filterByKeyword?.valueChanges?.subscribe({
			next : (value) => {
				this.searchText = value ?? "";
			}
		});

		this.filterBy?.valueChanges?.subscribe( {
			next : (data) => {	
				// guard against and infinite loop due to patch value on line 105 : this.filterBy.patchValue(this.filterByCouncilOrRegion, { emitEvent : true });	
				if(data !== "" && data === this.filterByValue )
				{
					return;
				}	
				if(!! data && this.formHasAreaSelections(this.filterByValue))
				{
					this.nextFilterByChange = data ?? "";
					// patch the value of the reactive form control to previous value, because it has changed
					this.filterBy?.patchValue(this.filterByValue, { emitEvent : true });
					this.showFeedbackDialog();					
					return;				
				}				
				
				this.filterByValue = data ?? "";
				this.markAsNotTouched();
				//this.setAreaSelectValidators();
			}
		});

		this.regionsFormArray.valueChanges.subscribe({
			next : (value) => {
				this.setRegionOrCouncilNestedFormArrayValidators(this.regionsFormArray?.controls, 
					LOOKUP_AREA_TYPES.Region, LOOKUP_AREA_TYPES.RegionBeachSite);				
			}
		});

		this.councilsFormArray.valueChanges.subscribe({
			next : (value) => {
				this.setRegionOrCouncilNestedFormArrayValidators(this.councilsFormArray?.controls,
					LOOKUP_AREA_TYPES.Council, LOOKUP_AREA_TYPES.CouncilBeachSite);				
			}
		});		
	}

	ngOnDestroy(): void {
		this.regionsSub && this.regionsSub?.unsubscribe();
		this.beachSitesSub && this.beachSitesSub?.unsubscribe();
		this.councilsSub && this.councilsSub?.unsubscribe();
	}

	ngAfterViewInit(): void {
		this.createFormControls();		
	}	
	

	get regionsFormArray()
	{
		return this.formGroup?.get("regionsArray") as FormArray;
	}

	get councilsFormArray()
	{
		return this.formGroup?.get("councilsArray") as FormArray;
	}

	get beachSitesFormArray()
	{
		return this.formGroup?.get("beachSitesArray") as FormArray;
	}

	get filterBy()
	{
		return this.formGroup?.get("filterBy") as FormControl;
	}

	get filterByKeyword()
	{
		return this.formGroup?.get("filterByKeyword") as FormControl;
	}


	public setCouncil = (councilName : string) => {
		if(!councilName)
		{
			return;
		}

		const index = this.allCouncils?.findIndex((council : Council) => {
			return council.CouncilName?.toLowerCase() === councilName?.toLowerCase();
		});
		if(-1 < index)
		{
			this.filterBy?.patchValue(this.FILTER_BY[1]);
			const grp = <FormGroup>this.councilsFormArray?.controls?.[index];
			if(grp)
			{
				grp.get(LOOKUP_AREA_TYPES.Council)?.patchValue(true);
				(<FormArray>grp.get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls?.forEach((ctrl : AbstractControl) => {
					(<FormControl>ctrl)?.patchValue(true);
				});
			}			 
		}	
	}

	public setBeachSite = (siteIdentifier : string) => {
		if(!siteIdentifier)
		{
			return;
		}

		const index = this.allBeachSites?.findIndex((site : BeachSite) => {
			return site.Identifier?.toLowerCase() === siteIdentifier?.toLowerCase();
		});
		if(-1 < index && 0 < this.beachSitesFormArray?.length)
		{
			this.filterBy?.patchValue(this.FILTER_BY[2]);
			this.beachSitesFormArray?.controls?.[index]?.patchValue(true);			
		}	
	}

	private createFormControls() {
		this.beachSitesSub = this.allBeachSites$.subscribe({
			next : (data) => 
			{				
				this.createBeachSitesArray();				
			},
			error : ( ex : Error) => {

			},
			complete : () => {
				
			}
		});		

		this.councilsSub = this.allCouncils$.subscribe({
			next : (data) => 
			{				
				this.createCouncilsArray();			
			},
			error : ( ex : Error) => {

			},
			complete : () => {
				
			}
		});		
		
		this.regionsSub = this.allRegions$.subscribe({
			next : (data) => 
			{				
				this.createRegionsArray();				
			},
			error : ( ex : Error) => {

			},
			complete : () => {
				
			}
		});	
	}
	
	private createCouncilsArray = () => {
		
		const array = this.councilsFormArray;
	
		if(array)
		{
			array?.clear();
			if(Array.isArray(this.allCouncils) && 0 < this.allCouncils?.length)
			{
				this.allCouncils?.forEach((council : Council) =>  {					
					const sites = this.fb.array([]);

					council.Sites.forEach((site : BeachSite) => 
					{					
						sites.push(this.fb.control(false));
					});
					const grp = this.fb.group({
						[LOOKUP_AREA_TYPES.Council]: this.fb.control(false), 
						[LOOKUP_AREA_TYPES.CouncilBeachSite] : sites
					});
					array?.push(<FormControl>(<unknown>grp));					
				});
			}			
		}
		
		this.setCouncil(this.preSelectedCouncil);
		
		/*
		this.councilsTreeData = [];
		this.allCouncils?.forEach((council : Council) =>  {				
			const councilTreeNode : TreeItemNode = {
				id : council.CouncilId,	
				label : council.CouncilName,
				data : council,
				children : []
			};
			council.Sites.forEach((site : BeachSite) => 
			{	
				const siteTreeNode : TreeItemNode = {
					id : site.Identifier,
					label : site.SiteName,
					data : site,
					children : []
				};
				councilTreeNode.children.push(siteTreeNode);					
			});	
			this.councilsTreeData.push(councilTreeNode);
		});
		*/

	}	

	private createRegionsArray = () => {
		
		const array = this.regionsFormArray;
		if(array)
		{
			array?.clear();			
			this.subRegionsOnly = [];
			if(Array.isArray(this.allRegions) && 0 < this.allRegions?.length)
			{		
				this.subRegionsOnly = this.allRegions?.filter((a : Region) => isSubRegion(a));
				this.subRegionsOnly?.forEach((region : Region) =>  {					
					
					const sites = this.fb.array([]);
					region.Sites.forEach((site : BeachSite) => 
					{
						sites.push(this.fb.control(false));
					});	
					const grp = this.fb.group({
						[LOOKUP_AREA_TYPES.Region] : this.fb.control(false), 
						[LOOKUP_AREA_TYPES.RegionBeachSite]  : sites
					});
					array?.push(<FormControl>(<unknown>grp));
				});
			}
		}
		
		/*
		this.regionsTreeData = [];
		this.allRegions?.forEach((region : Region) =>  {
			const regionTreeNode : TreeItemNode = {
				id : region.RegionId,	
				label : region.RegionName,
				data : region,
				children : []
			};
			
			region.Sites.forEach((site : BeachSite) => 
			{						
				const siteTreeNode : TreeItemNode = {
					id : site.Identifier,
					label : site.SiteName,
					data : site,
					children : []
				};
				regionTreeNode.children.push(siteTreeNode);
			});	
			this.regionsTreeData.push(regionTreeNode);
		});
		*/
	}

	private createBeachSitesArray = () => {
		
		const array = this.beachSitesFormArray;
		
		if(array)
		{
			array?.clear();
			if(Array.isArray(this.allBeachSites) && 0 < this.allBeachSites?.length)
			{
				this.allBeachSites?.forEach((site : BeachSite) =>  {
					array?.push(this.fb.control(false));
				});
			}			
		}

		this.setBeachSite(this.preSelectedBeachSite);

		/*
		this.beachSitesTreeData = [];
		this.allBeachSites?.forEach((site : BeachSite) =>  {			
			const siteTreeNode : TreeItemNode = {
				id : site.Identifier,
				label : site.SiteName,
				data : site,
				children : []
			};
			this.beachSitesTreeData.push(siteTreeNode);
		});
		*/
	}

	private setRegionOrCouncilNestedFormArrayValidators = (controls : any, areaType : LOOKUP_AREA_TYPES, subAreaType : LOOKUP_AREA_TYPES) => {
		// controls?.forEach((control : AbstractControl, index : number, arr : any[]) => {
		// 	if((<FormControl>control)?.get(areaType)?.value)
		// 	{
		// 		control.get(subAreaType)?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
		// 	}
		// 	else
		// 	{
		// 		control.get(subAreaType)?.clearValidators();
		// 	}
		// });		
	}

	isExpanded(areaType : Partial<LOOKUP_AREA_TYPES>, areaIndex : number) 
	{
		const arr = (LOOKUP_AREA_TYPES.Region === areaType) ? this.regionsExpanded : 
			(LOOKUP_AREA_TYPES.Council === areaType) ? this.councilsExpanded : [];

		return -1 < arr?.indexOf(areaIndex);
	}

	onExpandButtonClicked = (event : any, areaType : Partial<LOOKUP_AREA_TYPES>, areaIndex : number) => 
	{
		const arr = (LOOKUP_AREA_TYPES.Region === areaType) ? this.regionsExpanded : 
			(LOOKUP_AREA_TYPES.Council === areaType) ? this.councilsExpanded : [];

		if(Array.isArray(arr))
		{
			const index = arr?.indexOf(areaIndex);
			if(-1 < index)
			{
				arr.splice(index, 1);
			}
			else
			{
				arr.push(areaIndex);
			}
		}		
	}

	private formHasAreaSelections = (filterByOption : string) =>
	{
		if(LOOKUP_AREA_TYPES.Region === filterByOption)
		{
			return this.regionsFormArray.controls.some((control : AbstractControl) => {								
				return (<FormGroup>control)?.get(LOOKUP_AREA_TYPES.Region)?.value ||
					(<FormArray>(<FormGroup>control)?.get(LOOKUP_AREA_TYPES.RegionBeachSite))?.controls?.
					some((control : AbstractControl) => (<FormControl> control).value);			
			});
		}	
		else if(LOOKUP_AREA_TYPES.Council === filterByOption)
		{
			return this.councilsFormArray.controls.some((control : AbstractControl) => {								
				return (<FormGroup>control).get(LOOKUP_AREA_TYPES.Council)?.value ||
					(<FormArray>(<FormGroup>control).get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls?.
					some((control : AbstractControl) => (<FormControl> control).value);			
			});
		}	
		else if(LOOKUP_AREA_TYPES.BeachSite === filterByOption)
		{
			return this.beachSitesFormArray.controls.some((control : AbstractControl) => (<FormControl>control)?.value);				
		}

		return false;
	}

	setFormArrayControlsValue = (controls : AbstractControl[], value : any, reset : boolean = false) => {
		if(controls?.length)
		{
			controls?.forEach((ctrl : any) => {
				if(reset)
				{
					(<FormControl>ctrl).reset();
				}	
				else
				{
					(<FormControl>ctrl).patchValue(value);
				}
				
			});
		}
	}
	

	getAreaLabel(area : LOOKUP_AREA_TYPES, index : number, siteIndex? : number) {			
		let label = "";
		
		if(LOOKUP_AREA_TYPES.Region === area)
		{
			label = this.subRegionsOnly?.[index]?.RegionName;
		} 
		else if(LOOKUP_AREA_TYPES.Council === area) 
		{
			label = this.allCouncils?.[index]?.CouncilName;
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === area) 
		{
			label = this.allBeachSites?.[index]?.SiteName;
		}
		else if(LOOKUP_AREA_TYPES.CouncilBeachSite === area) 
		{
			const sites = this.allCouncils?.[index]?.Sites;	
			label = sites?.[siteIndex!]?.SiteName ?? "";
		}
		else if(LOOKUP_AREA_TYPES.RegionBeachSite === area) 
		{
			const sites = this.subRegionsOnly?.[index]?.Sites;	
			label = sites?.[siteIndex!]?.SiteName ?? "";
		}

		return label;
	}

	areaShown(area : LOOKUP_AREA_TYPES, index : number, siteIndex? : number) {
		let shown = true;
		if("" === this.searchText?.toString().trim())
		{
			return shown;
		}		

		if(LOOKUP_AREA_TYPES.Region === area)
		{
			const item = this.subRegionsOnly?.[index];
			console.log(`Area shown : ${item.RegionName} - ${item.RegionType} Index : ${index}`);
			if(item.RegionType?.toLowerCase() === RegionTypes.REGION.toLowerCase() || 0 === item.Sites?.length)
			{
				shown = false;
			}
			else
			{
				shown = item?.["RegionName"]?.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase()) || 
				-1 < item.Sites.findIndex((site : BeachSite) => site.SiteName.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase()));
			}
		}
		else if(LOOKUP_AREA_TYPES.Council === area)
		{
			const item = this.allCouncils?.[index];
			shown = 0 === item.Sites?.length ? false : 
				(item?.["CouncilName"]?.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase()) || 
				-1 < item.Sites.findIndex((site : BeachSite) => site.SiteName.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase())));
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === area)
		{
			const item = this.allBeachSites?.[index];
			shown = item?.["SiteName"]?.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase());
		}
		else if(LOOKUP_AREA_TYPES.CouncilBeachSite === area)
		{
			const item = this.allCouncils?.[index];
			const sites = item?.Sites;		
			shown = item?.["CouncilName"]?.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase()) || 				
				sites?.[siteIndex!]?.SiteName.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase());					
		}
		else if(LOOKUP_AREA_TYPES.RegionBeachSite === area)
		{
			const item = this.subRegionsOnly?.[index];
			const sites = item?.Sites;		
			shown = item?.["RegionName"]?.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase()) || 				
				sites?.[siteIndex!]?.SiteName.toLocaleLowerCase().includes(this.searchText?.toString().toLocaleLowerCase());					
		}
		return shown;		
	}	

	asFormControl(ctrl : any) {
		return ctrl as FormControl;
	}
	
	private markAsNotTouched = () => 
	{
		if(LOOKUP_AREA_TYPES.Region === this.filterByValue)
		{			
			this.regionsFormArray?.controls?.forEach((ctrl : AbstractControl) => {
				ctrl.markAsUntouched();				
			});
		}
		else if(LOOKUP_AREA_TYPES.Council === this.filterByValue)
		{
			this.councilsFormArray?.controls?.forEach((ctrl : AbstractControl) => {
				ctrl.markAsUntouched();				
			});
			this.councilsFormArray.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
			this.regionsFormArray.clearValidators();
			this.beachSitesFormArray.clearValidators();
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === this.filterByValue)			
		{
			this.beachSitesFormArray?.controls?.forEach((ctrl : AbstractControl) => {
				ctrl.markAsUntouched();				
			});			
		}
	}

	private setAreaSelectValidators = () => 
	{
		if(LOOKUP_AREA_TYPES.Region === this.filterByValue)
		{
			this.regionsFormArray?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
			this.councilsFormArray?.clearValidators();
			this.beachSitesFormArray?.clearValidators();
		}
		else if(LOOKUP_AREA_TYPES.Council === this.filterByValue)
		{
			this.councilsFormArray?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
			this.regionsFormArray?.clearValidators();
			this.beachSitesFormArray?.clearValidators();
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === this.filterByValue)			
		{
			this.beachSitesFormArray?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
			this.regionsFormArray?.clearValidators();
			this.councilsFormArray?.clearValidators();
		}
	}


	clearSelectedAreaOptions = (what : LOOKUP_AREA_TYPES = <LOOKUP_AREA_TYPES>this.filterBy?.value) => {
		let controls : AbstractControl<any>[] = [];
		if(this.FILTER_BY[2] === what)
		{
			controls = this.beachSitesFormArray?.controls;
			this.setFormArrayControlsValue(controls, false);								
		}		
		else if(this.FILTER_BY[0] === what)
		{
			controls = this.regionsFormArray?.controls;			
			controls.forEach((control : AbstractControl) => {
				control.get(LOOKUP_AREA_TYPES.Region)?.patchValue(false);
				this.setFormArrayControlsValue((<FormArray>control.get(LOOKUP_AREA_TYPES.RegionBeachSite))?.controls, false, true);
			});
		}
		else if(this.FILTER_BY[1] === what)
		{
			controls = this.councilsFormArray?.controls;				
			controls.forEach((control : AbstractControl) => {
				control.get(LOOKUP_AREA_TYPES.Council)?.patchValue(false);
				this.setFormArrayControlsValue((<FormArray>control.get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls, false, true);
			});
		}
	}

	selectAllAreaOptions = () => {
		let controls : AbstractControl<any>[] = [];
		if(this.FILTER_BY[2] === this.filterBy?.value)
		{
			controls = this.beachSitesFormArray?.controls;	
			this.setFormArrayControlsValue(controls, true);				
		}
		else if(this.FILTER_BY[0] === this.filterBy?.value)
		{
			controls = this.regionsFormArray?.controls;	
			controls.forEach((control : AbstractControl) => {
				control.get(LOOKUP_AREA_TYPES.Region)?.patchValue(true);
				this.setFormArrayControlsValue((<FormArray>control.get(LOOKUP_AREA_TYPES.RegionBeachSite))?.controls, true);
			});			
		}
		else if(this.FILTER_BY[1] === this.filterBy?.value)
		{
			controls = this.councilsFormArray?.controls;	
			controls.forEach((control : AbstractControl) => {
				control.get(LOOKUP_AREA_TYPES.Council)?.patchValue(true);
				this.setFormArrayControlsValue((<FormArray>control.get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls, true);
			});	
		}		
	}	

	onAreaCheckedChanged = (areaIndex : number) => {
		let areaControl, subControls;
		let parentKey : LOOKUP_AREA_TYPES, childKey : LOOKUP_AREA_TYPES, arr;
		if(LOOKUP_AREA_TYPES.Region === this.filterBy?.value)
		{
			parentKey = LOOKUP_AREA_TYPES.Region;
			childKey = LOOKUP_AREA_TYPES.RegionBeachSite;
			arr = this.regionsFormArray;					
		}
		else if(LOOKUP_AREA_TYPES.Council === this.filterBy?.value)
		{
			parentKey = LOOKUP_AREA_TYPES.Council;
			childKey = LOOKUP_AREA_TYPES.CouncilBeachSite;
			arr = this.councilsFormArray;					
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === this.filterBy?.value)
		{
			this.beachSitesFormArray?.controls?.[areaIndex]?.markAsTouched();
		}

		const grp = (<unknown>arr?.controls?.[areaIndex]) as FormGroup;
		if(grp  && (areaControl = grp.get(parentKey!)))
		{			
			areaControl.markAsTouched();
			this.setFormArrayControlsValue((<FormArray>grp.get(childKey!))?.controls, areaControl.value);			
		}
	} 

	onAreaBeachSiteChanged = (areaIndex : number,  siteIdx : number) => {
		let areaControl, subControls;
		let parentKey : LOOKUP_AREA_TYPES, childKey : LOOKUP_AREA_TYPES, arr;
		if(LOOKUP_AREA_TYPES.Region === this.filterBy?.value)
		{
			parentKey = LOOKUP_AREA_TYPES.Region;
			childKey = LOOKUP_AREA_TYPES.RegionBeachSite;
			arr = this.regionsFormArray;					
		}
		else if(LOOKUP_AREA_TYPES.Council === this.filterBy?.value)
		{
			parentKey = LOOKUP_AREA_TYPES.Council;
			childKey = LOOKUP_AREA_TYPES.CouncilBeachSite;
			arr = this.councilsFormArray;					
		}

		const grp = (<unknown>arr?.controls?.[areaIndex]) as FormGroup;
		if(grp)
		{
			areaControl = grp.get(parentKey!);
			subControls = (<FormArray>grp.get(childKey!))?.controls;				
			if(areaControl && subControls?.length && 
				subControls?.every((control : AbstractControl) => (<FormControl>control)?.value))
			{
				areaControl.patchValue(true);
			}
		}		
	}

	getAreaBeachSiteControls = (areaIdx : number, areaType : Partial<LOOKUP_AREA_TYPES>) => {
		let frmArray = this.fb.array([]);
		if(LOOKUP_AREA_TYPES.Region === areaType)
		{
			const grp = <FormGroup>(<unknown>this.regionsFormArray?.controls?.[areaIdx]);
			frmArray = grp.get(LOOKUP_AREA_TYPES.RegionBeachSite) as FormArray;
		}
		else if(LOOKUP_AREA_TYPES.Council=== areaType)
		{		
			const grp = <FormGroup>(<unknown>this.councilsFormArray?.controls?.[areaIdx]);			
			frmArray = grp.get(LOOKUP_AREA_TYPES.CouncilBeachSite) as FormArray;
		}
		
		return frmArray
	}

	applyFilter() {
		this.searchText = this.filterByKeyword?.value ?? "";	
	}

	showFeedbackDialog = () => {
		if(this.suppressPopup)
		{
			return;
		}		

		this.dialogData = {
			data : 
			{ 
				title : "Change filtering options?",
				content : "You are attempting to change filtering options while selections have been made from the list below. If you choose to proceed you will clear the " + this.filterBy?.value + " selections made.",
				acceptButtonText : "Clear all selections",
				cancelButtonText : "Cancel",
				showCancelButton : true,
				acceptClicked : this.onPopupAcceptClicked,
				cancelClicked : this.onPopupCancelClicked
		}};
		//this.showDialog = true;
		this.userfeedbackModaldialog.openDialog(this.dialogData);
	}

	hideFeedbackDialog = () => {		
		this.dialogData = null;
		this.showDialog = false;		
	}

	onPopupAcceptClicked = (event : any) => 
	{	
		this.hideFeedbackDialog();	
		this.clearSelectedAreaOptions();		
		this.filterBy?.patchValue(this.nextFilterByChange);
		this.nextFilterByChange = "";
		this.regionsExpanded = [];
		this.councilsExpanded = [];	
	}

	 onPopupCancelClicked  = (event : any) => {
		this.hideFeedbackDialog();
		this.nextFilterByChange = "";
		this.filterBy?.patchValue(this.filterByValue);
	 }

	 public reset()
	 {
		this.suppressPopup = true;
		this.searchText = "";
		this.filterByValue = "";
		this.filterBy?.reset();
		this.filterByKeyword?.reset();
		this.clearSelectedAreaOptions(LOOKUP_AREA_TYPES.Region);
		this.clearSelectedAreaOptions(LOOKUP_AREA_TYPES.Council);
		this.clearSelectedAreaOptions(LOOKUP_AREA_TYPES.BeachSite);
		this.setFormArrayControlsValue(this.regionsFormArray.controls as FormControl[], false, true);	
		this.setFormArrayControlsValue(this.councilsFormArray.controls as FormControl[], false, true);	
		this.setFormArrayControlsValue(this.beachSitesFormArray.controls as FormControl[], false, true);			
		this.suppressPopup = false;
	}
	
	get selectionValid() {
	
		let isValid = !this.required || (this.required && !!this.filterBy?.value);
		if(this.required && !!this.filterBy?.value)
		{
			if(this.filterBy?.value === LOOKUP_AREA_TYPES.Region)
			{		
				const someTouched = this.regionsFormArray?.controls?.some((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.Region))?.touched;
				});
				const selected = this.regionsFormArray?.controls?.map((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;					
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.RegionBeachSite))?.controls;
				}).flat()?.filter((ctrl:AbstractControl) => !!ctrl.value);	
				
				isValid = isValid && (!someTouched || (someTouched && 0 < selected.length));
				
			}
			else if(this.filterBy?.value === LOOKUP_AREA_TYPES.Council)
			{
				const someTouched = this.councilsFormArray?.controls?.some((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.Council))?.touched;
				});
				const selected = this.councilsFormArray?.controls?.map((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;					
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls;
				}).flat()?.filter((ctrl:AbstractControl) => !!ctrl.value);	

				isValid = isValid && (!someTouched || (someTouched && 0 < selected.length));
			}
			else if(this.filterBy?.value === LOOKUP_AREA_TYPES.BeachSite)
			{
				const someTouched = this.beachSitesFormArray?.controls?.some((ctrl : AbstractControl) => ctrl?.touched || ctrl?.dirty);
				const selected = this.beachSitesFormArray?.controls?.filter((ctrl : AbstractControl) => ctrl?.value);
				isValid = isValid && (!someTouched || (someTouched && 0 < selected.length));
			}	
		}		
		
		return isValid;	
	}
	
	get dirty()
	{
		return !!this.filterBy?.value || this.formHasAreaSelections(this.filterBy?.value);
	}


	get valid () 
	{
		let isValid = !this.required || (this.required && !!this.filterBy?.value);
		if(this.required && !!this.filterBy?.value)
		{
			if(this.filterBy?.value === LOOKUP_AREA_TYPES.Region)
			{						
				const childControls = this.regionsFormArray?.controls?.map((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.RegionBeachSite))?.controls;
				}).flat();				
				const anyChecked = childControls?.some((childCtrl : AbstractControl) => (<FormControl>childCtrl)?.value);	
				isValid = isValid && anyChecked;
			}
			else if(this.filterBy?.value === LOOKUP_AREA_TYPES.Council)
			{
				const childControls = this.councilsFormArray?.controls?.map((ctrl : AbstractControl) => {
					const grp = <FormGroup>ctrl;
					return (<FormArray>grp?.get(LOOKUP_AREA_TYPES.CouncilBeachSite))?.controls;
				}).flat();				
				const anyChecked = childControls?.some((childCtrl : AbstractControl) => (<FormControl>childCtrl)?.value);	
				isValid = isValid && anyChecked;
			}
			else if(this.filterBy?.value === LOOKUP_AREA_TYPES.BeachSite)
			{
				const anyChecked = this.beachSitesFormArray?.controls?.some((childCtrl : AbstractControl) => (<FormControl>childCtrl)?.value);
				isValid =  isValid && this.beachSitesFormArray?.valid ;
			}	
		}		
		
		return isValid;
	}


	public getSelectedBeachSites = (siteField : string = "Identifier", regionField : string = "RegionId", councilField : string = "CouncilId") => {
		const areaType = this.filterBy?.value;
		let sites : string[] = [];
		let regions : string[] = [];
		let councils : string[] = [];

		let sourceArray : any, subAreaPropName = "";	
		if(LOOKUP_AREA_TYPES.Region === areaType)
		{
			sourceArray = this.regionsFormArray;
			subAreaPropName = LOOKUP_AREA_TYPES.RegionBeachSite;
			regions = this.subRegionsOnly?.filter((region : Region, regionIdx : number, arr : Region[]) => {
				const grp = <FormGroup>(<unknown>this.regionsFormArray?.controls?.[regionIdx]);
				const regionSitesFormArray = grp?.get(LOOKUP_AREA_TYPES.RegionBeachSite) as FormArray;
				for(let i = 0; i < regionSitesFormArray?.controls?.length; ++i)
				{
					const siteControl = regionSitesFormArray?.controls?.[i] as FormControl;
					if(siteControl && siteControl?.value)
					{	
						sites.push(region.Sites?.[i]?.Identifier);
					}
				}
				return sourceArray?.controls?.[regionIdx]?.get(LOOKUP_AREA_TYPES.Region)?.value;				
			}).map((region : Region) => 
			{
				const value = (<{[s : string] : any}>region)?.[regionField];
				return (null == value ? "" : value?.toString());
			}).filter(Boolean);
		}
		else if(LOOKUP_AREA_TYPES.Council === areaType)
		{
			sourceArray = this.councilsFormArray;
			subAreaPropName = LOOKUP_AREA_TYPES.CouncilBeachSite;			
			councils = this.allCouncils?.filter((council : Council, councilIdx : number, arr : Council[]) => {
				const grp = <FormGroup>(<unknown>this.councilsFormArray?.controls?.[councilIdx]);
				const councilSitesFormArray = grp?.get(LOOKUP_AREA_TYPES.CouncilBeachSite) as FormArray;
				for(let i = 0; i < councilSitesFormArray?.controls?.length; ++i)
				{
					const siteControl = councilSitesFormArray?.controls?.[i] as FormControl;
					if(siteControl && siteControl?.value)
					{						
						sites.push(council.Sites?.[i]?.Identifier);
					}
				}
				return sourceArray?.controls?.[councilIdx]?.get(LOOKUP_AREA_TYPES.Council)?.value;				
			}).map((council : Council) => {				
					const value = (<{[s : string] : any}>council)?.[councilField];
					return (null == value ? "" : value?.toString());
			}).filter(Boolean);
		}
		else if(LOOKUP_AREA_TYPES.BeachSite === areaType)
		{			
			this.beachSitesFormArray?.controls?.forEach((control : any, siteIdx : number) => {	
				if(control.value)
				{
					const value = (<{[s : string] : any}>this.allBeachSites?.[siteIdx])?.[siteField];					
					sites.push((null == value ? "" : value?.toString()));
				}	
			});
		}
	

		return { sites : uniq(sites.filter(Boolean)), regions : uniq(regions), councils : uniq(councils) };
	}

	get validationErrorMessage () {
		switch(this.filterBy?.value)
		{			
			case LOOKUP_AREA_TYPES.Region:
				return "Please select at least one Site. Please note: There might be no sites under the selected Regions. In that case, please select other Regions.";
			case LOOKUP_AREA_TYPES.Council:
				return "Please select at least one Site. Please note: There might be no sites under the selected Councils. In that case, please select other Councils.";
			default : 
				return "Please select at least one Site";
		}		
		
	}
}
